import { CSSProperties } from 'react'
import css from './badgeCount.module.css'
import Skeleton from '@/shared/Loaders/Skeleton'
import formatUtils from '@/utils/format.utils'

export type TBadgeCount = 'success' | 'default' | 'error' | 'processing' | 'warning' | 'dark' | 'blue'

interface IProps {
  type: TBadgeCount
  count: number
  style?: CSSProperties
  loading?: boolean
}

const BadgeCount = (props: IProps) => {
  if (props.loading) {
    return <Skeleton height="20px" width="60px" style={{ borderRadius: '16px' }} />
  }

  return (
    <div className={css.wrapper} data-type={props.type} data-one-digit={props.count < 10} style={props.style}>
      <span className="text-sm" style={{ color: 'inherit' }}>
        {formatUtils.formatNumber(props.count)}
      </span>
    </div>
  )
}

export default BadgeCount
